export default __webpack_public_path__ + "static/media/Triggerpunktmassage.d876b181.jpeg";